import { render, staticRenderFns } from "./certificate.vue?vue&type=template&id=38c0eff2&scoped=true&"
import script from "./certificate.ts?vue&type=script&lang=ts&"
export * from "./certificate.ts?vue&type=script&lang=ts&"
import style0 from "./certificate.scss?vue&type=style&index=0&id=38c0eff2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c0eff2",
  null
  
)

export default component.exports